import { getKeys } from './getKeys'

export const accessControlTranslations = {
  TITLE_PREFERENCES: '{{nominative}} Access Settings',
  ACCESS_CONTROL_DESCRIPTION:
    'Control whether team members can view all {{nominative}} or only those assigned to them.',
  PRO_PLAN_INFO:
    'If you choose ‘Only Assigned {{nominative}}’, handovers will be disabled.',
  CHOSE_ACCESS_LEVEL: 'Choose access level:',
  SHOW_ALL: 'Show All {{nominative}}',
  ONLY_ASSIGNED: 'Show Only Assigned {{nominative}}',
  WHAT_IS_ACCESS_CONTROL: 'What is ‘{{nominative}} Access Settings’?',
  WHAT_IT_DOES: 'What this setting does:',
  SHOW_ALL_BULLET:
    '<strong>  ‘Show All {{nominative}}’</strong> - Carers can view every {{nominative}} in the app, even those they aren’t assigned to.',
  ONLY_ASSIGNED_BULLET:
    "<strong>‘Show Only Assigned {{nominative}}’</strong> - Carers only see {{nominative}} they've been assigned as their care team.",
  ROTA_BASED_ACCESS: 'Rota Based Access',
  ROTA_BASED_ACCESS_DESCRIPTION:
    "When enabled, carers can view full care information only for {{nominative}} they're scheduled to visit, and only within the defined access window (access window is customisable). They'll always have full access to {{nominative}} in their care team. When disabled, carers follow the primary access level chosen above (Show All or Only Assigned).",
  ROTA_BASED_ACCESS_INFO:
    'This option is only available if “Show Only Assigned {{nominative}}” is selected above.',
  WHAT_IS_ROTA_BASED_ACCESS: 'What is ‘Rota Based Access’?',
  ROTA_BASED_ACCESS_EXPLANATION:
    'As your site has the rota feature you can choose to show {{nominative}} data based on your rota allocations using the setting below.',
  MY_RESIDENTS: 'My {{nominative}}',
  BEFORE_THE_VISIT: 'before the visit',
  AFTER_THE_VISIT: 'after the visit',
  TYPE_HERE: 'Type here...',
  ACCESS_STARTS_LABEL: 'Access starts:',
  ACCESS_ENDS_LABEL: 'Access ends:',
  HOW_DO_I_SET_THIS_UP: 'How do I set this up?'
}

export const accessControlConstants = getKeys(accessControlTranslations)
